<form [formGroup]="classicForm" (ngSubmit)="onFormSubmit()">
  <formly-form  [model]="data" [fields]="classicBox"  [options]="options" [form]="classicForm">
  </formly-form>
</form>
